import { useContext, useEffect, useState } from 'react';

import { useLocation } from 'react-router';

import Datatable from '../../../Components/Datatable/Datatable';
import Loading from '../../../Components/Loading/Loading';
import ModalCustom from '../../../Components/Modal/ModalCustom';
import RemoveModal from '../../../Components/Modal/RemoveModal';
import TitleBar from '../../../Components/TitleBar/TitleBar';
import { useApi } from '../../../Hooks/Api';
import { useToast } from '../../../Hooks/Toast';
import Master from '../../../Layouts/Master';
import { LogContext } from '../Context/LogContext';

const Weight = () => {
  const context = useContext(LogContext);
  const { get, destroy } = useApi();
  const { error, success } = useToast();
  const { search } = useLocation();
  const [loading, setLoading] = useState(true);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalRemoveObject, setModalRemoveObject] = useState(undefined);
  const [removeLoading, setRemoveLoading] = useState(false);
  const [modalBeforeObject, setModalBeforeObject] = useState({});
  const [beforeModal, setBeforeModal] = useState(false);
  const [modalAfterObject, setModalAfterObject] = useState({});
  const [afterModal, setAfterModal] = useState(false);

  useEffect(() => {
    const getData = async () => {
      await getLog();
    };
    getData();
  }, [search]);

  const getLog = async () => {
    setLoading(true);
    await get(
      `/log${search}`,
      (res) => {
        context.logs = res;
        setLoading(false);
      },
      (err) => {
        error('هنگام دریافت اطلاعات خطایی رخ داده است.');
        setLoading(false);
      },
    );
  };

  const removeItem = async (id) => {
    setRemoveLoading(true);

    await destroy(
      `/log/${id}`,
      (res) => {
        success(`لاگ با موفقیت حذف شد.`);
        setRemoveLoading(false);
        setModalIsOpen(false);
        getLog();
      },
      (err) => {
        error('حذف به علت خطا انجام نشد.');
        setRemoveLoading(false);
      },
    );
  };

  return loading ? (
    <Loading />
  ) : (
    <>
      <Master>
        <TitleBar title='لیست لاگ ها' showCreateBtn={false} />
        <Datatable
          data={context.logs?.data}
          disableAllActions={true}
          meta={context.logs?.meta}
          search={search}
          setModalIsOpen={setModalIsOpen}
          setModalRemoveObject={setModalRemoveObject}
          basePagePath={`/log`}
          columns={[
            'صفحه',
            'API',
            'نام',
            'نام خانوادگی',
            'کد ملی',
            'استان',
            'نقش ها',
            'قبل از تغیرات',
            'بعد از تغیرات',
            'تاریخ ایجاد',
          ]}
          rows={[
            { name: 'page', type: 'string' },
            { name: 'api', type: 'string' },
            { name: 'first_name', type: 'string' },
            { name: 'last_name', type: 'string' },
            { name: 'national_card_id', type: 'string' },
            { name: 'province_name', type: 'string' },
            {
              name: 'role_names',
              type: 'relationArray',
              showField: 'description',
              relType: 'string',
            },
            {
              type: 'modal',
              setData: setModalBeforeObject,
              setModalIsOpen: setBeforeModal,
            },
            {
              type: 'modal',
              setData: setModalAfterObject,
              setModalIsOpen: setAfterModal,
            },
            { name: 'created_at', type: 'string' },
          ]}
        />
      </Master>
      <RemoveModal
        id={modalRemoveObject?.id}
        modalIsOpen={modalIsOpen}
        removeItem={removeItem}
        removeLoading={removeLoading}
        setModalIsOpen={setModalIsOpen}
        title={`آیا از حذف لاگ مطمئن هستید ؟`}
      />

      <ModalCustom modalIsOpen={beforeModal}>
        <div className='d-flex flex-row justify-content-between align-items-center border-bottom pb-2'>
          <span className=''>اطلاعات قبل از ویرایش</span>
          <i
            className='far fa-times text-white f-20 mx-2 c-pointer'
            onClick={() => setBeforeModal(false)}
          ></i>
        </div>
        <div
          className='w-100 my-3 bg-white f-15'
          dir='ltr'
          style={{ height: '400px', overflow: 'auto', textAlign: 'left' }}
        >
          <pre>{JSON.stringify(modalBeforeObject?.before_change, null, 2)}</pre>
        </div>
      </ModalCustom>

      <ModalCustom modalIsOpen={afterModal}>
        <div className='d-flex flex-row justify-content-between align-items-center border-bottom pb-2'>
          <span className=''>اطلاعات بعد از ویرایش</span>
          <i
            className='far fa-times text-white f-20 mx-2 c-pointer'
            onClick={() => setAfterModal(false)}
          ></i>
        </div>
        <div
          className='w-100 my-3 bg-white f-15'
          dir='ltr'
          style={{ height: '400px', overflow: 'auto', textAlign: 'left' }}
        >
          <pre>{JSON.stringify(modalAfterObject?.after_change, null, 2)}</pre>
        </div>
      </ModalCustom>
    </>
  );
};

export default Weight;
